module.exports = __webpack_public_path__ + "img/zhipai.0c6a3d48.svg";